import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Ad } from '@dmm/react-common-components';
import { BREAKPOINTS } from '../../utils/commonHelper';
import { listingPropTypes, premiumPlacementPropTypes } from '../../utils/commonPropTypes';
import ListingResult from '../ListingResult';
import LeaderBoardMid from '../Ads/LeaderBoardMid';
import MobileLinerAd from '../Ads/MobileLiner';
import PremiumPlacement from './components/PremiumPlacement';
import { setPosition } from '../../utils/paginationHelper';
import { get,isEmpty } from 'lodash';
import messages from '../../utils/translationMessages';
import SimilarListingsMessage from '../SimilarListingsMessage';
import { injectIntl } from 'react-intl';

import './styles.css';
import './home.css';

export const pageSizes = { [BREAKPOINTS.desktop]: 8, [BREAKPOINTS.tablet]: 6, [BREAKPOINTS.mobile]: 4 };

class BoatList extends React.PureComponent {
  render() {
    const AD_POSITION_OFFSET = 2;
    const AD_POSITION = 5;
    const MAX_DESKTOP_ADS = 2;
    let itemCount = 0;
    let desktopAdCount = 0;
    let mobileAdCount = 0;
    const {
      showAds,
      url,
      pos,
      tracking,
      labels,
      mode,
      breakpoint,
      adParams,
      showPremium,
      intl: { formatMessage: t },
      similarListings,
      similarListingsType,
      params } = this.props;
    const PREMIUM_POSITION = 4;
    const premiumPlacementAd = get(this.props, 'premiumPlacementAd', {});

    return (
      <ol className={classnames('boat-list', `boat-list-${mode}`)}>
        {

          this.props.listings.map((listing, i) => {
            if (mode === BoatList.MODES.home && breakpoint in pageSizes && i >= pageSizes[breakpoint]) {
              return [];
            }

            itemCount += 1;
            const position = setPosition(pos, i + 1);
            const listingArr = [
              <ListingResult
                key={listing.id}
                listing={listing}
                position={position}
                url={url}
                tracking={tracking}
                labels={labels}
                breakpoint={breakpoint}
                itemCount={itemCount}
                listingType={mode === BoatList.MODES.home ? 'latest listing' : ''}
                mode={mode === BoatList.MODES.home ? ListingResult.MODES.card : ListingResult.MODES.row}
              />
            ];
            if (showPremium && itemCount === PREMIUM_POSITION - 1 && !isEmpty(premiumPlacementAd))
            {
              let media = get(premiumPlacementAd,'media',[]);
              listingArr.push(
                <PremiumPlacement
                  key={get(premiumPlacementAd,'premiumPlacementId', i)}
                  description = {get(premiumPlacementAd,'description')}
                  title = {get(premiumPlacementAd,'title')}
                  boatLink = {get(premiumPlacementAd,'listingUrl')}
                  sellerName = {get(premiumPlacementAd,'seller.name')}
                  sellerLogo = {get(premiumPlacementAd,'seller.logo.url')}
                  mediaUrl = {(media.length > 0) ? media[0].url : null}
                  showMore = {t(messages.showMore)}
                  contact = {t(messages.contactGroup.contact)}
                  id= {get(premiumPlacementAd,'imtId')}
                  container= {get(premiumPlacementAd,'container')}
                  region= {get(premiumPlacementAd,'region')}
                />
              );
            }
            if (showAds && itemCount === AD_POSITION_OFFSET) {
              listingArr.push(<li key={`deskAd${listing.id}`}><Ad {...adParams.leaderBoardAlphaParams} /></li>);
            } else
            if (showAds && (itemCount - AD_POSITION_OFFSET) % AD_POSITION === 0 && desktopAdCount < MAX_DESKTOP_ADS) {
              listingArr.push(<LeaderBoardMid key={`deskAd${listing.id}`} adNum={++desktopAdCount}/>);
            }
            if (showAds && itemCount % AD_POSITION === 0 && mobileAdCount < MAX_DESKTOP_ADS) {
              listingArr.push(<MobileLinerAd key={`mobAd${listing.id}`} adNum={++mobileAdCount}/>);
            }
            return listingArr;
          }).reduce((prev, next) => [prev, ...next], [])
        }
        { similarListings && similarListings.length ?
          <SimilarListingsMessage params={params} similarListingsType={similarListingsType} /> : <></> }
        {
          similarListings && similarListings.slice(0,
            (similarListings.length + this.props.listings.length) < 28
              ? similarListings.length :
              28 - this.props.listings.length).map((listing, i) => {

            itemCount += 1;
            const position = setPosition(pos, i + 1);
            const listingArr = [
              <ListingResult
                key={listing.id}
                listing={listing}
                position={position}
                url={url}
                tracking={tracking}
                labels={labels}
                itemCount={itemCount}
              />
            ];

            return listingArr;
          }).reduce((prev, next) => [prev, ...next], [])
        }
      </ol>
    );
  }
}

BoatList.MODES = {
  results: 'results',
  home: 'home'
};

BoatList.defaultProps = {
  mode: BoatList.MODES.results,
  similarListings: [],
  showAds: false,
};

BoatList.propTypes = {
  adParams: PropTypes.object,
  breakpoint: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
  labels: PropTypes.object.isRequired,
  listings: PropTypes.arrayOf(listingPropTypes).isRequired,
  premiumPlacementAd: premiumPlacementPropTypes,
  similarListings: PropTypes.arrayOf(listingPropTypes),
  similarListingsType: PropTypes.string,
  params: PropTypes.object,
  mode: PropTypes.oneOf(Object.keys(BoatList.MODES)),
  pos: PropTypes.shape({
    page: PropTypes.string,
    pageSize: PropTypes.string,
  }).isRequired,
  tracking: PropTypes.object,
  url: PropTypes.string,
  itemCount: PropTypes.number,
  showAds: PropTypes.bool,
  showPremium: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(BoatList);
